import Vue from 'vue'
import Vuex from 'vuex'
import {driverCollection} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        data:{
          name:'',
          description:'',
          document:'',
          createdAt:'',
        },
        record:{},
        selectedKey: '',
        dialog: false,
      },
      mutations: {
        getAllItems(state, item) {
          Vue.set( state.record, item.id, {...item.data(), creado_el: secondsToFullTimestamp(item.data().creado_el)} )
        },
        clean(state,key){
          Vue.delete(state.record,key)
        }
      },
      actions: {
        
        getAll:(context)=>{
          context.state.record = {}
          driverCollection.get().then(data=>data.docs.map( item => {context.commit( 'getAllItems', item  ) }) )
        },
        
        add:context=>{
          
          if(context.state.selectedKey==''){
            driverCollection.add({...context.state.data, creado_el:new Date}).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo conductor correctamente', { root: true })
              cleanObject(context.state.data)
              context.state.dialog = false
            })
          }else{
            driverCollection.doc(context.state.selectedKey).update(context.state.data).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.data)
              context.state.dialog = false
            })
          }
        },
        clean:(context, key)=>{
            driverCollection.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
            driverCollection.doc(key).get().then(doc=>{
            context.state.data = doc.data()
            context.state.selectedKey = key
            context.state.dialog = true
          })
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.data = {
            name: '',
            description:'',
            document:'',
            createdAt: ''
          }
        },
      },
      getters: {
        record: state => Object.keys(state.record).map(item => ({...state.record[item], key: item }) ),
      },
  }
  